/** @file       my-identity/style.css
 *  @author     Alex Huctwith <alex@kingsds.network>
 *
 *  @date       April 2022
 *
 *             Style for the my identity component
 */
.userInfo {
  padding: 1em 2em 1em;
  display: block;
  overflow:visible;
  word-wrap: auto;
}

.userInfo h2 {
  color: #3A3A3A;
  font-size: 1em;
}

.userInfo > div {
  flex: 1 1 auto;
}

#id-info {
  margin-block-start: 0;
  margin-block-end: 0;
}

.data > p {
  margin-block-start: 5px;
  margin-block-end: 0;
}

.data {
  display: flex;
  flex-direction: row;
  align-items: baseline;
}

#userCreationDate {
  margin-left: auto;
}

#userEmail {
  font-size: 1.33em;
  overflow-wrap: break-word;
}

@media only screen and (max-width: 768px) {
  .userInfo {
    display: block;
  }

  .userInfo .label {
    max-width: 100%;
  }

  .userInfo .data {
    max-width: 80.5vw;
  }

  .userInfo .data p {
    font-size: 3.5vw;
  }
}

@media only screen and (max-width: 480px) {
  .userInfo .data p {
    font-size: 3.2vw;
  }

  .userInfo .data {
    max-width: 81.5vw;
  }
}
